import { JSONResponse } from './json-response';
import config from '../../config';
var Http = /*@__PURE__*/ (function () {
    function Http() {
    }
    Http.lastModified = function (url, absolute) {
        return new Promise(function (resolve, reject) {
            var prefix = config.API_DATA_PATH;
            if (absolute) {
                prefix = '';
            }
            jQuery.ajax({
                url: prefix + url,
                method: 'HEAD',
                success: function (res, x, head) {
                    resolve(head.getResponseHeader('last-modified'));
                },
                error: function (e) {
                    reject(e);
                }
            });
        });
    };
    Http.get = function (url, params, absolute) {
        return new Promise(function (resolve, reject) {
            var prefix = config.API_DATA_PATH;
            if (absolute) {
                prefix = '';
            }
            jQuery.ajax({
                url: prefix + url,
                success: function (res) {
                    resolve(new JSONResponse(res));
                },
                error: function (e) {
                    if (!e.responseText) {
                        reject(e);
                        return;
                    }
                    resolve(new JSONResponse(e.responseText));
                }
            });
        });
    };
    Http.post = function (url, params, absolute, form) {
        return new Promise(function (resolve, reject) {
            var prefix = config.API_DATA_PATH;
            if (absolute) {
                prefix = '';
            }
            var contentType;
            if (!form) {
                contentType = 'application/json';
                params = JSON.stringify(params);
            }
            jQuery.ajax({
                url: prefix + url,
                data: params,
                method: 'POST',
                contentType: contentType,
                success: function (res) {
                    resolve(new JSONResponse(res));
                },
                error: function (e) {
                    if (!e.responseText) {
                        reject(e);
                        return;
                    }
                    resolve(new JSONResponse(e.responseText));
                }
            });
        });
    };
    return Http;
}());
export { Http };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/core/utils/http.ts
// module id = null
// module chunks = 